import React, { useState } from 'react';
import StaticPage, { Section } from './StaticPage';

const faqs = [
  { q: 'How do I search for accommodation?', a: 'Use the search bar on the homepage. You can search by city, university, or property name. Filter by price, room type, and move-in date.' },
  { q: 'Is RentalX free for students?', a: 'Yes — completely free. You can browse listings, contact landlords, and book accommodation at no cost.' },
  { q: 'How do I know a listing is genuine?', a: 'Look for the blue Verified badge. All verified landlords have had their identity and property ownership confirmed by our team. Never pay without a signed lease.' },
  { q: 'How do I contact a landlord?', a: 'Click the "Contact Landlord" button on any listing page. You\'ll need to create a free account first.' },
  { q: 'Can I book before I arrive in Australia?', a: 'Yes! Many landlords accept online bookings. Use video call viewings and look for the Verified badge for extra confidence.' },
  { q: 'What if a property looks different from the photos?', a: 'Contact our support team immediately at hello@rentalx.com.au. We take misrepresentation seriously and can assist with mediation.' },
  { q: 'How does the bond (deposit) work?', a: 'The bond is paid directly to the landlord and must be lodged with your state\'s bond authority (e.g., RTBA in Victoria) within 10 days of your lease start.' },
  { q: 'How do I create a landlord account?', a: 'Click "Login" then "Create Landlord Account". Fill in your details and complete the verification process to start listing.' },
  { q: 'How do I edit or delete my listing?', a: 'Log in to your landlord dashboard, go to My Properties, and click Edit or Delete on the relevant listing.' },
  { q: 'What payment methods are accepted?', a: 'Rent payments are arranged directly between you and your landlord. RentalX subscription fees (for landlords) are paid via credit/debit card.' },
];

export default function HelpCenter() {
  const [open, setOpen] = useState(null);
  return (
    <StaticPage title="Help Center" subtitle="Find answers to common questions about RentalX.">
      <Section title="Frequently Asked Questions">
        <div className="space-y-2">
          {faqs.map((item, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                className="w-full text-left p-4 font-medium text-gray-800 flex justify-between items-center hover:bg-gray-50 transition-colors"
                onClick={() => setOpen(open === i ? null : i)}
              >
                {item.q}
                <span className={`text-[#094f6f] font-bold text-lg transition-transform ${open === i ? 'rotate-45' : ''}`}>+</span>
              </button>
              {open === i && (
                <div className="px-4 pb-4 text-gray-600 text-sm">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      </Section>

      <Section title="Still Need Help?">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { icon: '✉️', title: 'Email Support', desc: 'hello@rentalx.com.au', sub: 'Response within 24 hours' },
            { icon: '📞', title: 'Phone Support', desc: '+61 1800 RENTAL', sub: 'Mon–Fri 9am–5pm AEST' },
            { icon: '💬', title: 'Live Chat', desc: 'Available in the app', sub: 'Mon–Fri 9am–8pm AEST' },
          ].map((c, i) => (
            <div key={i} className="p-5 bg-sky-50 rounded-xl border border-sky-100 text-center">
              <div className="text-3xl mb-2">{c.icon}</div>
              <p className="font-semibold text-gray-800">{c.title}</p>
              <p className="text-[#094f6f] font-medium text-sm mt-1">{c.desc}</p>
              <p className="text-gray-500 text-xs mt-1">{c.sub}</p>
            </div>
          ))}
        </div>
      </Section>
    </StaticPage>
  );
}
